import {
  Component,
  ElementRef,
  AfterViewInit,
} from '@angular/core';

import { ADA_UNAVAILABLE_MODAL_SELECTOR } from '@lib/utils';

@Component({
  selector: 'ada-unavailable-modal',
  templateUrl: './ada-unavailable-modal.component.html',
  styleUrls: ['./ada-unavailable-modal.component.scss'],
})
export class AdaUnavailableModalComponent implements AfterViewInit {
  public isModalOpen: boolean;
  public modalId: string;
  private el: HTMLElement;
  private adaUnavailableModal: any;

  constructor(elRef: ElementRef) {
    this.el = elRef.nativeElement;
    this.modalId = ADA_UNAVAILABLE_MODAL_SELECTOR.slice(1); // remove #
  }

  public ngAfterViewInit() {
    this.adaUnavailableModal = this.el.querySelector(ADA_UNAVAILABLE_MODAL_SELECTOR);
  }

  public closeModal(): void {
    this.adaUnavailableModal.classList.remove('show');
  }
}
